import { createContext, useContext, useState, useEffect } from 'react';
import { translations, blogPosts } from '../i18n/translations';
import { useTranslation } from 'react-i18next';
import '../i18n/i18nConfig';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [language, setLanguageState] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'it';
  });

  const setLanguage = (lang) => {
    setLanguageState(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
  };

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language, i18n]);

  const t = translations[language];
  const posts = blogPosts[language];

  const toggleLanguage = () => {
    const next = language === 'it' ? 'en' : 'it';
    setLanguage(next);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t, posts }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
